import React, { createContext, useContext, useCallback } from 'react';
// import { NavigationItems } from '@/services/supabase/navigation';
import { NavigationItems } from '@/services/supabase/navigation';
import { useClearNavigationCache } from '@/services/query/navigation-queries';

interface NavigationContextProps {
  navItems: NavigationItems | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  clearCache: (projectId: string | number) => void;
}

const NavigationContext = createContext<NavigationContextProps>({
  navItems: null,
  isLoading: false,
  error: null,
  refetch: async () => { },
  clearCache: () => { },
});

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider: React.FC<{
  children: React.ReactNode;
  projectId: string | number | undefined;
}> = ({ children, projectId }) => {
  // Use TanStack Query hook to fetch navigation items
  // OPTIMIZATION: Disabled global fetch of all items to improve performance
  // specific pages should fetch what they need
  /* 
  const {
    data: navItems,
    isLoading,
    error,
    refetch
  } = useNavigationItems(projectId);
  */

  const navItems = { folders: [], entities: [] }; // Empty default
  const isLoading = false;
  const error = null;
  const refetch = async () => { }; // No-op

  // Use TanStack Query mutation to clear cache
  const clearCacheMutation = useClearNavigationCache();

  // Function to refetch navigation items
  const fetchNavItems = useCallback(async () => {
    if (!projectId) return;
    // await refetch();
  }, [projectId]);

  // Function to clear cache and refetch
  const handleClearCache = useCallback((projectId: string | number) => {
    clearCacheMutation.mutate(projectId);
  }, [clearCacheMutation]);

  return (
    <NavigationContext.Provider
      value={{
        navItems,
        isLoading,
        error,
        refetch: fetchNavItems,
        clearCache: handleClearCache,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};